import { render } from "./reports.vue?vue&type=template&id=1867e82c&scoped=true"
import script from "./reports.vue?vue&type=script&lang=js"
export * from "./reports.vue?vue&type=script&lang=js"

import "./reports.vue?vue&type=style&index=0&id=1867e82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1867e82c"]])

export default __exports__